import AddProductDialogOrig from "../../../../components/dialog/addProductDialog/AddProductDialog";

export default function AddProductDialog({
  isOpen, onClose, addingProduct, addedProducts, tabPosition
})  {

  return (
    <AddProductDialogOrig
      open={isOpen}
      onClose={onClose(null)}
      addProduct={(addProductData, part, _price, _dispOrder) => {
        onClose({
          status: "SUBMITTED",
          product: {
            addingProduct: addProductData,
            tabPos: part
          }
        })();
      }}
      productData={addingProduct}
      tabPosition={tabPosition}
      addedProductList={addedProducts.map((p) => ({...p, priceDetailTypeId: p.supplyTypeId}))}
      predictAddedProduct={(prod, addedProd) => 
        prod.productId === addedProd.productId
          && prod.originId === addedProd.originId
          && prod.rankId === addedProd.rankId
          && prod.productClassId === addedProd.productClassId
          && prod.packingId === addedProd.packingId
          && prod.weight === addedProd.weight
          && prod.weightUnitId === addedProd.weightUnitId
          && prod.orderUnitId === addedProd.orderingUnitId
      }
      openAddProductMasterDialog={(product) => onClose({status: "ADD_PRODUCT_MASTER", product})()}
      openAddProductDetailMasterDialog={(product) => onClose({status: "ADD_PRODUCT_DETAIL_MASTER", product})()}
      hidePrice
      hideDisplayOrder
    />
  );
}
  